var React = require('react');

function Houzz (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"}));
}

Houzz.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fab","data-icon":"houzz","className":"svg-inline--fa fa-houzz fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = Houzz;

Houzz.default = Houzz;
